import { QueryClientProvider } from '@tanstack/react-query';
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { DefinitionDrawer } from '#/components/content/DefinitionDrawer';
import { SkeletonModeBadge } from '#/components/layout/SkeletonModeBadge';
import { SkipLinks } from '#/components/layout/SkipLinks';
import { FullPageNotFound } from '#/components/ui/FullPageNotFound';
import { DefinitionDrawerProvider } from '#/context/DefinitionDrawerContext';
import { useRootContainer } from '#/context/RootContainerContext';
import { queryClient } from '#/lib/query-client';
import type { BreadcrumbContext } from '#/types/router';
import { APP_NAME_BREADCRUMB } from '#/utils/constants';

export const Route = createRootRouteWithContext<BreadcrumbContext>()({
  staticData: { breadcrumb: APP_NAME_BREADCRUMB },
  notFoundComponent: () => <FullPageNotFound />,
  component: () => (
    <QueryClientProvider client={queryClient}>
      <DefinitionDrawerProvider>
        <SkipLinks />
        <Outlet />
        <DefinitionDrawer />
        {import.meta.env.DEV && (
          <>
            <SkeletonModeBadge />
            <DevTools />
          </>
        )}
      </DefinitionDrawerProvider>
    </QueryClientProvider>
  ),
});

function DevTools() {
  const rootContainer = useRootContainer();

  return (
    <TanStackRouterDevtools
      position="bottom-right"
      shadowDOMTarget={rootContainer ?? undefined}
    />
  );
}
